import * as ko from 'knockout';

import { BaseCheckItem } from '../BaseCheckItem';
import { ICheckItemParams } from '../ICheckItemParams';

import Template from 'Core/Components/ActionCheckList/CheckItems/DateTime/Templates/Template.html';
import { ICON_CLASSES } from 'Core/Controls/DateTime/Icons';
import { FIELD_TYPES } from 'Core/Constant';
import moment from 'moment';
import { DATE_FORMATS } from 'Core/Constants/DateTimeFormats';
import { FormatConverter } from 'FormatEditor/FormatConverter';

ko.templates['Core/Components/ActionCheckList/CheckItems/DateTime/Templates/Template'] = Template;

export class DateTimeCheckItem extends BaseCheckItem {
  private _displayValue: KnockoutObservable<string>;

  constructor(params: ICheckItemParams) {
    super(params);

    if (params.Value) {
      const valueWithTimezone =
        params.TypeName === FIELD_TYPES.Date
          ? params.Value
          : FormatConverter.CorrectTimezone(params.Value);

      this._displayValue = ko.observable(moment(valueWithTimezone).format(this.DateTimeFormat));
    } else {
      this._displayValue = ko.observable(null);
    }
  }

  OnDateChanged(event): void {    
    if(event == null || event === '' || event === undefined){
      this.Value(null);
    }else{
      this.Value(moment(event).format());
    }
  }

  get DateTimeFormat() {
    if (this.TypeName === FIELD_TYPES.Date) {
      return DATE_FORMATS.SHORT_DATE.Format;
    }

    if (this.TypeName === FIELD_TYPES.DateTime) {
      return DATE_FORMATS.DATE_TIME.Format;
    }
  }

  GetTemplateName(): string {
    return 'Core/Components/ActionCheckList/CheckItems/DateTime/Templates/Template';
  }

  GetDateFormatIconClass(): string {
    if (this.TypeName === FIELD_TYPES.Date) {
      return ICON_CLASSES[FIELD_TYPES.Date];
    }

    if (this.TypeName === FIELD_TYPES.DateTime) {
      return ICON_CLASSES[FIELD_TYPES.DateTime];
    }
  }

  GetLocale() {
    return moment.locale();
  }
}
